/**
 * @license
 *
 * Copyright IBM Corp. 2021, 2025
 *
 * This source code is licensed under the Apache-2.0 license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Gradient Direction
 */
export enum GRADIENT_DIRECTION {
  /**
   * Left to right
   */
  LEFT_TO_RIGHT = 'left-to-right',

  /**
   * Right to left
   */
  RIGHT_TO_LEFT = 'right-to-left',

  /**
   * Top to Bottom
   */
  TOP_TO_BOTTOM = 'top-to-bottom',
}

/**
 * Mobile Position
 */
export enum MOBILE_POSITION {
  /**
   * Top
   */
  TOP = 'top',

  /**
   * Bottom
   */
  BOTTOM = 'bottom',
}
